import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component to let the user select a boolean value. It is displayed as a
 * switch.
 * @remarks If using v-wmodel, always add the modifier .lazy
 */
var SwitchComponent = /** @class */ (function (_super) {
    __extends(SwitchComponent, _super);
    function SwitchComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Emitted when control state has changed.
     * Provides value indicating whether the control is switched on or off
     */
    SwitchComponent.prototype.onChange = function (val) {
        return val;
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SwitchComponent.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SwitchComponent.prototype, "right", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SwitchComponent.prototype, "inline", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], SwitchComponent.prototype, "twoState", void 0);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], SwitchComponent.prototype, "onChange", null);
    SwitchComponent = __decorate([
        Component({
            name: 'ui-switch',
            inheritAttrs: false,
        })
    ], SwitchComponent);
    return SwitchComponent;
}(Mixins(MagicConfigMixin)));

export default SwitchComponent;
